var React = require('react');

function Ps (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-118 0h682.7v512H-118z"}))),React.createElement("g",{"clipPath":"url(#a)","transform":"translate(110.6) scale(.9375)","key":1},React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"d":"M-246 0H778v170.7H-246z","key":0}),React.createElement("path",{"fill":"#fff","d":"M-246 170.7H778v170.6H-246z","key":1}),React.createElement("path",{"fill":"#090","d":"M-246 341.3H778V512H-246z","key":2}),React.createElement("path",{"fill":"red","d":"M-246 512l512-256L-246 0v512z","key":3})]))]);
}

Ps.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ps;

Ps.default = Ps;
